import { z } from 'zod'

// Agency schema for form validation and data handling
export const agencySchema = z.object({
  id: z.string(),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  fullName: z.string().optional(),
  email: z.string().email('Invalid email address'),
  phoneNumber: z.string().min(1, 'Phone number is required'),
  status: z.enum(['Active', 'Suspended', 'Pending', 'Disabled']),
  avatarUrl: z.string().optional(),
  organizationId: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
})

// Create agency form schema (without id, status, and timestamps)
export const createAgencySchema = agencySchema
  .omit({
    id: true,
    fullName: true,
    status: true,
    avatarUrl: true,
    organizationId: true,
    createdAt: true,
    updatedAt: true,
  })
  .extend({
    password: z.string().min(6, 'Password must be at least 6 characters'),
    prefix: z.string().min(1, 'Phone prefix is required'),
  })

// Update agency form schema (excludes id, password, and timestamps)
export const updateAgencySchema = agencySchema
  .omit({
    id: true,
    fullName: true,
    createdAt: true,
    updatedAt: true,
  })
  .extend({
    prefix: z.string().min(1, 'Phone prefix is required'),
  })

export type Agency = z.infer<typeof agencySchema>
export type CreateAgencyInput = z.infer<typeof createAgencySchema>
export type UpdateAgencyInput = z.infer<typeof updateAgencySchema>

export const agencyListSchema = z.array(agencySchema)
